import React, { useEffect, useState } from 'react'
import { openModal } from '../../../../../Library/ModalPopUp';
import { MessageError, MessageSuccess } from '../../../../Student/Profiles/components/ProfileUI';
import { UPDATE_CANDIDATE } from '../../../../Student/Profiles/API';
import { EncodeURIComponentSafe } from '../../../../../Library/GlobalHelper';
import { handleKeyDown } from '../../../../Student/Profiles/_core/_core';
import { SelectCity, SelectCountry, SelectKecamatan, SelectProvince } from '../../../../Student/Profiles/_core/SelectInput';
import { Card } from 'react-bootstrap';

export function FormContacts({ data }) {
    const [errors, setErrors] = useState({});
    const [addr, setAddr] = useState(data?.address || "");
    const [country_id, setCountry_id] = useState(data?.country_id || 0);
    const [city, setCity] = useState(data?.city || "");
    const [city_id, setCity_id] = useState(data?.city_id || 0);
    const [province_id, setProvince_id] = useState(data?.city_obj?.province_id || 0);
    const [kecamatan_id, setKecamatan_id] = useState(data?.kecamatan_id || 0);
    const [kelurahan, setKelurahan] = useState(data?.kelurahan || "");
    const [postalcode, setPostalcode] = useState(data?.postalcode || "");

    const validateForm = () => {
        let newErrors = {};

        if (!addr.trim()) newErrors.addr = "Address is required";
        if (!country_id) newErrors.country_id = "Country is required";
        if (!city) newErrors.city_id = "City is required";

        if (country_id === 103) {
            if (!province_id) newErrors.province_id = "Province is required";
            if (!kecamatan_id) newErrors.kecamatan_id = "Kecamatan is required";
            if (!postalcode) newErrors.postalcode = "Postalcode is required";

            if (!kelurahan.trim()) {
                newErrors.kelurahan = "Kelurahan is required";
            } else if (kelurahan.trim().length < 3) {
                newErrors.kelurahan = "Kelurahan must be at least 3 characters";
            } else if (/^\s|\s$/.test(kelurahan)) {
                newErrors.kelurahan = "Kelurahan cannot start or end with a space";
            }
        }

        setErrors(newErrors);
    };

    useEffect(() => {
        validateForm();
    }, [
        addr,
        country_id,
        city_id,
        province_id,
        kecamatan_id,
        kelurahan,
        postalcode,
    ]);

    const [submit, setSubmit] = useState({
        loading: false,
        data: [],
        message: "",
    });

    const SubmitHandler = async (e) => {
        e.preventDefault();
        if (Object.keys(errors).length === 0) {
            setSubmit({ loading: true, message: "", data: [] });
            const param_enrollment = {
                id: data?.id,
                address: EncodeURIComponentSafe(addr),
                country_id,
                city: EncodeURIComponentSafe(city),
                postalcode: postalcode,
                province_id,
                kecamatan_id,
                kelurahan: EncodeURIComponentSafe(kelurahan),
            }
            try {
                const results = await UPDATE_CANDIDATE(param_enrollment);
                if (results.data && Object.values(results.data).length > 0) {
                    openModal({
                        message: <MessageSuccess message={"Successfully saved"} />,
                    });
                    // ReloadDataStd();
                } else {
                    openModal({
                        message: (
                            <MessageError message={results.message} title="Failed Save" />
                        ),
                    });
                }
                setSubmit(results);
            } catch (error) {
                setSubmit({ loading: false, message: error?.message, data: [] });
                openModal({
                    message: (
                        <MessageError message={error?.message} />
                    ),
                });
            }
        } else {
            openModal({
                message: (
                    <MessageError
                        message={
                            "Please verify your input and ensure it is completed correctly."
                        }
                    />
                ),
            });
            setSubmit({ loading: false, message: "", data: [] });
        }
    }
    return (
        <Card>
            <Card.Body>
                <form method="post" autoComplete="off" onSubmit={(e) => SubmitHandler(e)}>
                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Address <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-8">
                            <textarea
                                name="address"
                                className="form-control form-control-lg form-control-solid"
                                defaultValue={addr}
                                onChange={(e) => setAddr(e.target.value)}
                            ></textarea>
                            {errors.addr && <div className="text-danger">{errors.addr}</div>}
                        </div>
                    </div>

                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            City <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-4">
                            <input type="text" className="form-control form-control-lg form-control-solid" value={city} onChange={(e) => setCity(e.target.value)} placeholder="City" />
                            {errors.city && (
                                <div className="text-danger">{errors.city}</div>
                            )}
                        </div>
                    </div>

                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Province <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-4">
                            <SelectProvince
                                data={province_id}
                                setData={setProvince_id}
                                isSolid={true}
                            />
                            {errors.province_id && (
                                <div className="text-danger">{errors.province_id}</div>
                            )}
                        </div>
                    </div>

                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Country <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-4">
                            <SelectCountry
                                data={country_id}
                                setData={setCountry_id}
                                isSolid={true}
                            />
                            {errors.country_id && (
                                <div className="text-danger">{errors.country_id}</div>
                            )}
                        </div>
                    </div>

                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Kecamatan <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-4">
                            <SelectKecamatan
                                data={kecamatan_id}
                                setData={setKecamatan_id}
                                isSolid={true}
                                city_id={city_id}
                            />
                            {errors.kecamatan_id && (
                                <div className="text-danger">{errors.kecamatan_id}</div>
                            )}
                        </div>
                    </div>

                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Kelurahan <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                className="form-control form-control-lg form-control-solid"
                                value={kelurahan}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                    const regex = /^\s|\s{2,}|^\s+$/;
                                    if (!regex.test(inputValue)) {
                                        setKelurahan(inputValue);
                                    }
                                }}
                            />
                            {errors.kelurahan && (
                                <div className="text-danger">{errors.kelurahan}</div>
                            )}
                        </div>
                    </div>

                    <div className="row mb-8">
                        <label className="col-lg-4 col-form-label required font-weight-semibold h6">
                            Postal Code <sup className="text-danger">*</sup>
                        </label>
                        <div className="col-lg-4">
                            <input
                                type="text"
                                name="postalcode"
                                className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                                onKeyDown={handleKeyDown}
                                onInput={(e) => {
                                    const value = e.target.value.replace(/\D/g, "");
                                    setPostalcode(value);
                                }}
                                value={postalcode}
                            />
                            {errors.postalcode && (
                                <div className="text-danger">{errors.postalcode}</div>
                            )}
                        </div>
                    </div>

                    <div className="text-right mt-8">
                        <button
                            className="btn btn-lg btn-primary mr-3"
                            type="submit"
                            disabled={submit.loading}
                        >
                            {submit.loading ? "Processing..." : "Save Changes"}
                        </button>
                    </div>
                </form>
            </Card.Body>
        </Card>
    )
}
